import { ShiftModalDetailsData } from 'modals/ShiftModal/ShiftModal.constants';
import { ActivityTab } from 'components/ActivityTab/ActivityTab';
import { AuditTrailActivityTab } from 'components/AuditTrailActivityTab/AuditTrailActivityTab';
import { AvailableMembersTab } from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab';
import { GeneralTab } from 'modals/ShiftModal/src/views/DetailView/GeneralTab/GeneralTab';
import { TimesheetsTab } from 'modals/ShiftModal/src/views/DetailView/TimesheetsTab';
import { Order } from 'types/graphql';

export const DetailViewComponentMap = {
  GeneralTab,
  ActivityTab,
  AvailableMembersTab,
  TimesheetsTab,
  AuditTrailActivityTab,
};

export type DetailViewActiveTabType = keyof typeof DetailViewComponentMap;

export interface IDetailViewComponentProps {
  data: ShiftModalDetailsData;
  setActiveSubView: (activeSubView: DetailViewActiveTabType) => void;
  activeSubView: DetailViewActiveTabType;
}

export interface IDetailViewFooterProps {
  order: Order;
  validateAndExecute: () => void;
  goToSendToAgenciesView: () => void;
  goToReleaseShiftView: () => void;
  goToEditView: () => void;
  goToDeleteView: () => void;
  isBlockShift: boolean;
  isBlockDeleteConfirmationOpen: boolean;
  setIsBlockDeleteConfirmationOpen: (isOpen: boolean) => void;
}
